import {
    CR_SUPPLIER,
    CR_SUPPLIER_SUCCESS,
    CR_SUPPLIER_ERROR,
    CR_DELIVERY_ORDER,
    CR_DELIVERY_ORDER_SUCCESS,
    CR_DELIVERY_ORDER_ERROR,
    CR_ASSIGNED_USER,
    CR_ASSIGNED_USER_SUCCESS,
    CR_ASSIGNED_USER_ERROR,
    CR_STATUS,
    CR_STATUS_SUCCESS,
    CR_STATUS_ERROR,
    CR_LIST,
    CR_LIST_SUCCESS,
    CR_LIST_ERROR,
    CR_LIST_SEARCH_CHANGE,
    CR_LIST_PAGE_SET,
    CR_ASSIGN_MODAL_SET,
    CR_ASSIGN_CHANGE_SET,
    CR_ASSIGN,
    CR_ASSIGN_SUCCESS,
    CR_ASSIGN_ERROR,
    CR_LIST_UNASSIGNED,
    CR_LIST_UNASSIGNED_SUCCESS,
    CR_LIST_UNASSIGNED_ERROR,
    CR_LIST_USER,
    CR_LIST_USER_SUCCESS,
    CR_LIST_USER_ERROR,
    CR_VERIFY_MODAL_SET,
    CR_VERIFY_CHANGE_SET,
    CR_VERIFY,
    CR_VERIFY_SUCCESS,
    CR_VERIFY_ERROR,
} from "../../actions";

const INIT_STATE = {
    loading: false,
    list: {
        page: {
            current: 1,
            rows: 10
        }
    },
    supplier: {
        loading: false,
        data: []
    },
    deliveryorder: {
        loading: false,
        data: []
    },
    assigneduser: {
        loading: false,
        data: []
    },
    status: {
        loading: false,
        data: []
    },
    listunassigned: {
        loading: false,
        data: []
    },
    listuser: {
        loading: false,
        data: []
    },
    assign: {
        data: [],
        modal: false,
        loading: false,
        message: '',
        url: '',
        type: ''
    },
     verify: {
        data: [],
        modal: false,
        loading: false,
        message: '',
        url: '',
        type: ''
    },
    error: false,
    search: {
        modal: false,
        init: true,
        data: {
            supplier: '',
            deliveryorder: '',
            assigneduser:'',
            status: '',
            unassigned: '',
            upload: '',
            pending_upload: '',
            pending_review: '',
            rejected:''
        },
        value: {
            supplier: '',
            deliveryorder: '',
            assigneduser: '',
            status: '',
            unassigned: '',
            upload: '',
            pending_upload: '',
            pending_review: '',
            rejected: ''
        }
    }
};


export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case CR_SUPPLIER:
            return {
                ...state,
                loading: true,
                supplier: {
                    ...state.supplier
                }
            }
        case CR_SUPPLIER_SUCCESS:
            return {
                ...state,
                loading: false,
                supplier: {
                    ...state.supplier,
                    ...action.payload
                }
            }
        case CR_SUPPLIER_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case CR_DELIVERY_ORDER:
            return {
                ...state,
                loading: true,
                deliveryorder: {
                    ...state.deliveryorder
                }
            }
        case CR_DELIVERY_ORDER_SUCCESS:
            return {
                ...state,
                loading: false,
                deliveryorder: {
                    ...state.deliveryorder,
                    ...action.payload
                }
            }
        case CR_DELIVERY_ORDER_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case CR_ASSIGNED_USER:
            return {
                ...state,
                loading: true,
                assigneduser: {
                    ...state.assigneduser
                }
            }
        case CR_ASSIGNED_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                assigneduser: {
                    ...state.assigneduser,
                    ...action.payload
                }
            }
        case CR_ASSIGNED_USER_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case CR_STATUS:
            return {
                ...state,
                loading: true,
                status: {
                    ...state.status
                }
            }
        case CR_STATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                status: {
                    ...state.status,
                    ...action.payload
                }
            }
        case CR_STATUS_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case CR_LIST:
            return {
                ...state,
                loading: true,
                list: {
                    ...state.list
                }
            }

        case CR_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case CR_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }

        case CR_LIST_PAGE_SET:
            return {
                ...state,
                list: {
                    ...state.list,
                    page: {
                        ...state.list.page,
                        ...action.payload,
                    }
                }
            }
        case CR_LIST_SEARCH_CHANGE:
            return {
                ...state,
                search: {
                    ...state.search,
                    data: action.payload,
                }
            }
        case CR_ASSIGN_MODAL_SET:
            return {
                ...state,
                assign: {
                    ...state.assign,
                    modal: action.payload
                }
            }
        case CR_ASSIGN_CHANGE_SET:
            return {
                ...state,
                assign: {
                    ...state.assign,
                    data: {
                        ...state.assign.data,
                        ...action.payload
                    }
                }
            }
        case CR_ASSIGN:
            return {
                ...state,
                assign: {
                    ...state.assign,
                    loading: false
                }
            }
        case CR_ASSIGN_SUCCESS:
            return {
                ...state,
                assign: {
                    ...state.assign,
                    modal: false,
                    loading: false,
                    url: action.payload.url,
                    type: action.payload.type,
                    message: action.payload.message
                },
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case CR_ASSIGN_ERROR:
            return {
                ...state,
                assign: {
                    ...state.assign,
                    loading: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }
        case CR_LIST_UNASSIGNED:
            return {
                ...state,
                loading: true,
                listunassigned: {
                    ...state.listunassigned
                }
            }
        case CR_LIST_UNASSIGNED_SUCCESS:
            return {
                ...state,
                loading: false,
                listunassigned: {
                    ...state.listunassigned,
                    ...action.payload
                }
            }
        case CR_LIST_UNASSIGNED_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case CR_LIST_USER:
            return {
                ...state,
                loading: true,
                listuser: {
                    ...state.listuser
                }
            }
        case CR_LIST_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                listuser: {
                    ...state.listuser,
                    ...action.payload
                }
            }
        case CR_LIST_USER_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case CR_VERIFY_MODAL_SET:
            return {
                ...state,
                verify: {
                    ...state.verify,
                    modal: action.payload
                }
            }
        case CR_VERIFY_CHANGE_SET:
            return {
                ...state,
                verify: {
                    ...state.verify,
                    data: {
                        ...state.verify.data,
                        ...action.payload
                    }
                }
            }
        case CR_VERIFY:
            return {
                ...state,
                verify: {
                    ...state.verify,
                    loading: false
                }
            }
        case CR_VERIFY_SUCCESS:
            return {
                ...state,
                verify: {
                    ...state.verify,
                    modal: false,
                    loading: false,
                    url: action.payload.url,
                    type: action.payload.type,
                    message: action.payload.message
                },
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case CR_VERIFY_ERROR:
            return {
                ...state,
                verify: {
                    ...state.verify,
                    loading: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }

        default:
            return { ...state };
    }
};